import axios from 'axios';
import { isEmpty } from 'lodash';
import _get from 'lodash/get';
import { getCsrfToken } from '../../helpers/twHelper';
import { CONTACT_TOPIC_TREE_INTENTS } from '../../common/storeConstants';

export const REQUEST_CALL_US_INFO = 'REQUEST_CALL_US_INFO';
export const RECEIVED_CALL_US_INFO = 'RECEIVED_CALL_US_INFO';
export const CALL_US_INFO_ERROR = 'CALL_US_INFO_ERROR';
export const RESET_CALL_US_INFO = 'RESET_CALL_US_INFO';
export const STORE_CHATBOT_PARAMS = 'STORE_CHATBOT_PARAMS';

let URL = '/smarthelp/api/phone-info';

export const storeChatBotParams = (params) => {
  return {
    type: STORE_CHATBOT_PARAMS,
    payload: params,
  };
};

export const requestContactInfo = () => ({
  type: REQUEST_CALL_US_INFO,
});

export const receivedCallUsInfo = (data) => ({
  type: RECEIVED_CALL_US_INFO,
  payload: data,
});

export const callUsInfoError = () => ({
  type: CALL_US_INFO_ERROR,
});

export const resetCallUsInfo = () => ({
  type: RESET_CALL_US_INFO,
});

export const getFinalIntentTopicRefId = (state) => {
  // from logged out to loggIn
  if (state.modal && state.modal.topic) {
    return _get(state, 'modal.topic.topicRefId');
  }

  return _get(state, `${CONTACT_TOPIC_TREE_INTENTS}.selectedFinalIntent.ref_id`);
};

export const getPhoneInfo = () => (dispatch, getState) => {
  dispatch(requestContactInfo());
  if (!isEmpty(getState().contactTopicTreeIntentsV2.selectedFinalIntent)) {
    //  const topicRefId = getState().contactTopicTreeIntentsV2.selectedFinalIntent.ref_id
  }
  URL = `${URL}?topic_id=1256820`;
  return axios
    .get(URL)
    .then((response) => {
      dispatch(receivedCallUsInfo(response.data));
    })
    .catch(() => {
      return dispatch(callUsInfoError());
    });
};

export const doWebPinAuth = (options) => () => {
  const phoneURL = '/smarthelp/ivr-web-auth';
  return axios.post(phoneURL, { _csrf: getCsrfToken(), webMobileInfo: options }).then().catch();
};
